import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAllGetGroupVesselList = (data) => {
  return axios.get(`${apiurl?.getPpeVesselGroup}?searchCriteria=${data?.searchCriteria}&Page=${data?.Page}&PageSize=${data?.PageSize}&isAll=${data?.isAll}`);
};

const getGroupVesselList = (data) => {
  return useQuery(['getPpeVesselGroup', data], () => fetchAllGetGroupVesselList(data), { refetchOnWindowFocus: false });
};

export default getGroupVesselList;
